import React, { Component } from 'react';

class LargeImageModal extends Component {
  constructor(props) {
    super(props);
  }

  render() { 
    return (
    <div style={{display:'flex', justifyContent:'center', alignItems:'center', overflow:'scroll', height:'400px'}} >
        {this.props.img && <img style={{width:'900px'}} src={this.props.img} />}
    </div>
    );
  }
}

export default LargeImageModal;




// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/LargeImageModal.jsx